import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const fetchAllProjects = createAsyncThunk(
  "getAllProjects",
  async ({ token, instanceLinks }, { rejectWithValue }) => {
    try {
      const responses = await Promise.all(
        instanceLinks.map((link) =>
          axios
            .get(`${link}/api/Project/GetAll`, {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            })
            .then((response) => ({
              data: response.data.data,
              source: link,
            }))
            .catch((error) => {
              // eslint-disable-next-line no-console
              console.error(`Error fetching projects from ${link}:`, error);
              return { error: true, source: link };
            })
        )
      );

      // Process only successful responses
      const combinedData = responses.flatMap((response) => {
        if (response.data) {
          return response.data.map((project) => ({
            ...project,
            source: response.source,
          }));
        } else {
          return [];
        }
      });

      return combinedData;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error("Unexpected error:", error);
      return rejectWithValue(error.response?.data?.title || error?.message || "Unexpected error");
    }
  }
);

const fetchAllProjectsSlice = createSlice({
  name: "allProjects",
  initialState: {
    isLoading: false,
    data: null,
    isError: false,
    errorMessage: "",
    success: null,
  },
  extraReducers: (builder) => {
    builder.addCase(fetchAllProjects.pending, (state) => {
      state.isLoading = true;
      state.errorMessage = "";
      state.success = null;
    });
    builder.addCase(fetchAllProjects.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
      state.success = true;
    });
    builder.addCase(fetchAllProjects.rejected, (state, action) => {
      state.errorMessage = action.payload;
      state.isError = true;
      state.isLoading = false;
      state.success = false;
    });
  },
});

export default fetchAllProjectsSlice.reducer;
